import { NPSScore, NPSScoreCreateBody } from './../../../shared/models/nps-score.model';
import { HttpClient } from '@angular/common/http';
import { environment } from './../../../../environments/environment';
import { Injectable } from '@angular/core';
import { BehaviorSubject, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NpsTrackingService {

  private baseURL = `${environment.baseURL}/nps-scores`;
  private emailLoaded = '';
  private npsScoresList = new BehaviorSubject<NPSScore[]>([]);

  constructor(private http: HttpClient) { }

  getNPSByCustomerEmail(email: string) {
    if (this.npsScoresList.value.length === 0 && this.emailLoaded !== email) {
      this.emailLoaded = email;
      this.getNPSScoreList(email);
    }
    return this.npsScoresList.asObservable();
  }

  createNPS(userEmail: string, score: number, notes: string | null) {
    let body: NPSScoreCreateBody = {
      id: null,
      score: score - 1,
      email: userEmail,
      timestamp: new Date().toISOString(),
      notes: notes
    }
    return this.http.post<NPSScore>(`${this.baseURL}`, body).pipe(tap((_) => this.getNPSScoreList(userEmail)));
  }

  updateNPS(id: number, userEmail: string, score: number, notes: string | null) {
    let body: NPSScoreCreateBody = {
      id,
      score: score - 1,
      email: userEmail,
      timestamp: new Date().toISOString(),
      notes: notes
    }
    return this.http.put<NPSScore>(`${this.baseURL}/${id}`, body).pipe(tap((_) => this.getNPSScoreList(userEmail)));
  }

  resetNPSScoreList() {
    this.npsScoresList.next([]);
  }

  private getNPSScoreList(email: string) {
    this.http.get<NPSScore[]>(`${this.baseURL}/user?email=${email}`)
      .subscribe((scores) => this.npsScoresList.next(scores));
  }
}
